module.exports = __webpack_public_path__ + "static/media/vocoder.e244d6c3.png";